module.exports = __webpack_public_path__ + "static/img/make-panel.77e9858.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/make-panel.jpg
// module id = hdCd
// module chunks = 1